<script lang="ts">
	import { ArrowDown } from "luxedo-icons"

	interface Props {
		isFlipped: boolean
	}
	let { isFlipped }: Props = $props()
</script>

<div class="toggle-arrow" class:isFlipped>
	<ArrowDown />
</div>

<style>
	.toggle-arrow {
		width: 2rem;
		height: 2rem;
		transition: transform var(--transition-duration) var(--transition-timing);
	}

	.toggle-arrow.isFlipped {
		transform: rotateX(180deg);
	}

	.toggle-arrow :global(svg) {
		width: 2rem;
		height: 2rem;
	}

	.toggle-arrow :global(.svg-stroke) {
		stroke: var(--color-main);
	}
</style>
